import React from 'react'
import { Outlet } from 'react-router-dom'

function MainMyTasks() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainMyTasks
